import { useContext } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom"
import { PublicRoutes, PrivateRoutes} from './';
import { AuthContext } from '../context/authContext';

//type Status = 'checking' | 'authenticated' | 'no-authenticated'
//let status: Status = 'no-authenticated'

export const AppRouter = () => {    
    const { isAuthenticated, authReady } = useContext(AuthContext)

    if (!authReady) {
        // Loader simple mientras chequea autenticación inicial
        return (
            <div className="min-h-screen flex items-center justify-center bg-white dark:bg-gray-900 text-gray-700 dark:text-gray-100">
                <span>Verificando sesión...</span>
            </div>
        );
    }

    return (
        <>
            <BrowserRouter>
                <Routes>
                    {
                        isAuthenticated === false
                            ? <Route path="/*" element={<PublicRoutes />} />
                            : <Route path="/*" element={<PrivateRoutes />} />
                    }

                    <Route path='*' element={<Navigate to='/login' replace />} />
                </Routes>
            </BrowserRouter>
        </>
    )
}